import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import * as H from 'preact/hooks';
import { Fixtuur, Render } from '@fixtuur/backpack';
import { useSelector } from '../../store/redux';
import * as Selectors from '../../store/selectors';

/**
 * A hook to collect everything needed to render the current Visual Inspiration product when using the Brenda renderer.
 */
export const useRenderableForCurrentInspirationProduct = (
    currentProduct: Fixtuur.Product.Product | null,
) => {
    const serviceConfig = useSelector(Selectors.Core.serviceConfig);

    return H.useMemo(() => {
        return pipe(
            O.Do,
            O.bind('currentProduct', () => O.fromNullable(currentProduct)),
            O.bind('serviceConfig', () => O.fromNullable(serviceConfig)),
            O.map(({ currentProduct, serviceConfig }) => {
                const id = Fixtuur.Product.id(currentProduct);
                const placement = Fixtuur.Product.placement(currentProduct);
                const modelUrl = Fixtuur.Product.getModelUrl(serviceConfig, currentProduct);
                const usdzModelUrl = Fixtuur.Product.getUSDZModelUrl(serviceConfig, currentProduct);

                return Render.Product.create(id, modelUrl, usdzModelUrl, placement);
            }),
            O.toUndefined,
        );
    }, [currentProduct, serviceConfig]);
};
